import { BETA_KEYS, LOCAL_STORAGE } from '@/constants';

// Only seeded when a browser has no stored betas yet, i.e. for users who haven't used the app
// before. Existing users keep whatever they already have - adding a key here never changes them.
export const defaultBetasStorage = [BETA_KEYS.REPORTS_BETA, BETA_KEYS.COMPOSE_BETA];

const getBetaStatus = (betaKey: string) => {
    const enabledBetas = localStorage.getItem(LOCAL_STORAGE.ENABLED_BETAS);
    if (enabledBetas) {
        try {
            const parsedBetaEnabled = JSON.parse(enabledBetas);
            if (Array.isArray(parsedBetaEnabled)) {
                return parsedBetaEnabled.includes(betaKey);
            }
        } catch (e) {
            // If parsing fails, reset to default betas
            localStorage.setItem(LOCAL_STORAGE.ENABLED_BETAS, JSON.stringify(defaultBetasStorage));
            return defaultBetasStorage.includes(betaKey);
        }
    }
    // Create with default betas if none are stored
    localStorage.setItem(LOCAL_STORAGE.ENABLED_BETAS, JSON.stringify(defaultBetasStorage));
    return defaultBetasStorage.includes(betaKey);
};
export default getBetaStatus;
